import React from 'react';
import { IonRouterOutlet } from '@ionic/react';
import { Route } from 'react-router-dom';
import NearestDestinationRedirect from './NearestDestinationRedirect';
import ShareWizardRedirect from './ShareWizardRedirect';
import RecipientsStep from './RecipientsStep';
import ChangesStep from './ChangesStep';
import StyleStep from './StyleStep';
import IntroMessageStep from './IntroMessageStep';
import ReminderMessageStep from './ReminderMessageStep';
import UpdateMessageStep from './UpdateMessageStep';
import ShareConfirmStep from './ShareConfirmStep';
import FinalShareConfirmStep from './FinalShareConfirmStep';

/**
 * The URL segments only the garden flow has. A session that was in the garden
 * flow when the flag went off lands on one of these, which the wizard cannot
 * render; written as an alternation so the route is mutually exclusive with the
 * step routes below, because IonRouterOutlet does not disambiguate overlapping
 * matches by declaration order.
 */
const GARDEN_ONLY_SEGMENTS = ':segment(composer)';

/**
 * The classic wizard: eight routed steps over the sharing session.
 *
 * Mounted by `ShareFlowGate` when `topicGardenEnabled` is off, inside the
 * session provider and the shared flow shell, which own the page this outlet
 * renders into.
 */
const ShareWizardRouter: React.FC = () => {
  return (
    <IonRouterOutlet className="share-wizard__outlet">
      <Route
        exact
        path="/topics/:topicId/share"
        component={ShareWizardRedirect}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/recipients"
        component={RecipientsStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/changes"
        component={ChangesStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/tone"
        component={StyleStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/intro-message"
        component={IntroMessageStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/reminder-message"
        component={ReminderMessageStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/update-message"
        component={UpdateMessageStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/share-confirm"
        component={ShareConfirmStep}
      />
      <Route
        exact
        path="/topics/:topicId/share/steps/final-share-confirm"
        component={FinalShareConfirmStep}
      />
      <Route
        exact
        path={`/topics/:topicId/share/steps/${GARDEN_ONLY_SEGMENTS}`}
        render={() => <NearestDestinationRedirect surface="wizard" />}
      />
    </IonRouterOutlet>
  );
};

export default ShareWizardRouter;
